// extracted by mini-css-extract-plugin
export default {"tenderResultContainer":"TenderResult_tenderResultContainer__zNORp"};